/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DoctorVisitTypeDto
 */
export interface DoctorVisitTypeDto {
    /**
     * 
     * @type {number}
     * @memberof DoctorVisitTypeDto
     */
    'additionalTimeGrossPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof DoctorVisitTypeDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorVisitTypeDto
     */
    'doctorPackageOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DoctorVisitTypeDto
     */
    'doctorPriceListItemId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DoctorVisitTypeDto
     */
    'documents'?: string;
    /**
     * 
     * @type {number}
     * @memberof DoctorVisitTypeDto
     */
    'durationFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof DoctorVisitTypeDto
     */
    'durationStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof DoctorVisitTypeDto
     */
    'durationTo'?: number;
    /**
     * 
     * @type {number}
     * @memberof DoctorVisitTypeDto
     */
    'grossPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof DoctorVisitTypeDto
     */
    'medicalService'?: DoctorVisitTypeDtoMedicalServiceEnum;
    /**
     * 
     * @type {string}
     * @memberof DoctorVisitTypeDto
     */
    'medicalServiceGroup'?: DoctorVisitTypeDtoMedicalServiceGroupEnum;
    /**
     * 
     * @type {number}
     * @memberof DoctorVisitTypeDto
     */
    'referralId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DoctorVisitTypeDto
     */
    'scope'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorVisitTypeDto
     */
    'visitOrder'?: DoctorVisitTypeDtoVisitOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof DoctorVisitTypeDto
     */
    'visitType'?: DoctorVisitTypeDtoVisitTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DoctorVisitTypeDtoMedicalServiceEnum {
    Visit0 = 'VISIT_0',
    Visit1 = 'VISIT_1',
    StandardVisit = 'STANDARD_VISIT',
    StandardVisit15 = 'STANDARD_VISIT_15',
    FollowupVisit = 'FOLLOWUP_VISIT',
    Message = 'MESSAGE',
    Prescription = 'PRESCRIPTION',
    AbsentConsultation = 'ABSENT_CONSULTATION',
    NeurosurgeonConsultation = 'NEUROSURGEON_CONSULTATION',
    NeuropsychologistConsultation = 'NEUROPSYCHOLOGIST_CONSULTATION',
    NeurologopedistConsultation = 'NEUROLOGOPEDIST_CONSULTATION',
    PsychiatristConsultation = 'PSYCHIATRIST_CONSULTATION',
    GeneticistConsultation = 'GENETICIST_CONSULTATION',
    EpileptologistConsultation = 'EPILEPTOLOGIST_CONSULTATION',
    NeurologistConsultation = 'NEUROLOGIST_CONSULTATION',
    DieticianConsultation = 'DIETICIAN_CONSULTATION',
    VnsConsultation = 'VNS_CONSULTATION',
    MetabolicConsultation = 'METABOLIC_CONSULTATION',
    SleepDisturbanceConsultation = 'SLEEP_DISTURBANCE_CONSULTATION',
    CaseConference = 'CASE_CONFERENCE',
    AdhdConsultation = 'ADHD_CONSULTATION',
    PsychotherapyConsultation = 'PSYCHOTHERAPY_CONSULTATION',
    TmsQualificationConsultation = 'TMS_QUALIFICATION_CONSULTATION',
    TmsInductionConsultation = 'TMS_INDUCTION_CONSULTATION',
    Tms15MConsultation = 'TMS_15M_CONSULTATION',
    Tms30MConsultation = 'TMS_30M_CONSULTATION',
    Tms45MConsultation = 'TMS_45M_CONSULTATION',
    EegConsultation = 'EEG_CONSULTATION',
    VeegNightConsultation = 'VEEG_NIGHT_CONSULTATION',
    VeegDayConsultation = 'VEEG_DAY_CONSULTATION',
    VeegOnStandbyConsultation1H = 'VEEG_ON_STANDBY_CONSULTATION_1H',
    VeegOnStandbyConsultation2H = 'VEEG_ON_STANDBY_CONSULTATION_2H',
    VeegOnStandbyConsultation6H = 'VEEG_ON_STANDBY_CONSULTATION_6H',
    VeegDuringSleepConsultation1H = 'VEEG_DURING_SLEEP_CONSULTATION_1H',
    VeegDuringSleepConsultation2H = 'VEEG_DURING_SLEEP_CONSULTATION_2H',
    VeegDuringSleepConsultation6H = 'VEEG_DURING_SLEEP_CONSULTATION_6H',
    MigrationVisit = 'MIGRATION_VISIT',
    VeegOnStandbyConsultation = 'VEEG_ON_STANDBY_CONSULTATION',
    VeegDuringSleepConsultation = 'VEEG_DURING_SLEEP_CONSULTATION',
    PartnerConsultation = 'PARTNER_CONSULTATION'
}
/**
    * @export
    * @enum {string}
    */
export enum DoctorVisitTypeDtoMedicalServiceGroupEnum {
    AbsentConsultation = 'ABSENT_CONSULTATION',
    Visit0 = 'VISIT_0',
    MigrationVisit = 'MIGRATION_VISIT',
    Visit1 = 'VISIT_1',
    FollowupVisit = 'FOLLOWUP_VISIT',
    StandardVisit = 'STANDARD_VISIT',
    Message = 'MESSAGE',
    Prescription = 'PRESCRIPTION',
    MetabolicConsultation = 'METABOLIC_CONSULTATION',
    NeurosurgeonConsultation = 'NEUROSURGEON_CONSULTATION',
    NeuropsychologistConsultation = 'NEUROPSYCHOLOGIST_CONSULTATION',
    NeurologopedistConsultation = 'NEUROLOGOPEDIST_CONSULTATION',
    PsychiatristConsultation = 'PSYCHIATRIST_CONSULTATION',
    GeneticistConsultation = 'GENETICIST_CONSULTATION',
    EpileptologistConsultation = 'EPILEPTOLOGIST_CONSULTATION',
    NeurologistConsultation = 'NEUROLOGIST_CONSULTATION',
    DieticianConsultation = 'DIETICIAN_CONSULTATION',
    VnsConsultation = 'VNS_CONSULTATION',
    EegConsultation = 'EEG_CONSULTATION',
    SleepDisturbanceConsultation = 'SLEEP_DISTURBANCE_CONSULTATION',
    CaseConference = 'CASE_CONFERENCE',
    PartnerConsultation = 'PARTNER_CONSULTATION',
    AdhdConsultation = 'ADHD_CONSULTATION',
    PsychotherapyConsultation = 'PSYCHOTHERAPY_CONSULTATION',
    StandardVisit15 = 'STANDARD_VISIT_15',
    TmsQualificationConsultation = 'TMS_QUALIFICATION_CONSULTATION',
    TmsConsultation = 'TMS_CONSULTATION'
}
/**
    * @export
    * @enum {string}
    */
export enum DoctorVisitTypeDtoVisitOrderEnum {
    Each = 'EACH',
    First = 'FIRST',
    Next = 'NEXT'
}
/**
    * @export
    * @enum {string}
    */
export enum DoctorVisitTypeDtoVisitTypeEnum {
    Remote = 'REMOTE',
    Stationary = 'STATIONARY',
    Absent = 'ABSENT'
}


